export const symptomOptions = [
    { value: 'fever', label: 'Fiebre' },
    {
        value: 'cough_sore_throat_or_breathing_difficulty',
        label: 'Tos, dolor de garganta o dificultad para respirar',
    },
    { value: 'severe_headache', label: 'Dolor de cabeza severo' },
    { value: 'diarrhea_or_vomiting', label: 'Diarrea o vómito' },
    {
        value: 'skin_injuries_or_infections',
        label: 'Heridas o infecciones en la piel',
    },
    { value: 'eye_infections', label: 'Infecciones oculares' },
    { value: 'none', label: 'Ninguno' },
]

export const trainingOptions = [
    { value: 'yes', label: 'Sí' },
    { value: 'no', label: 'No' },
    { value: 'in_progress', label: 'En curso' },
]

export function formatFssc22000Boolean(value) {
    if (value === '' || value === null || typeof value === 'undefined') {
        return '—'
    }
    if (value === true || value === 1 || value === '1') {
        return 'Sí'
    }
    if (value === false || value === 0 || value === '0') {
        return 'No'
    }
    return String(value)
}

export function labelForFssc22000Option(options, value) {
    if (!value) return '—'
    const match = options.find(option => option.value === value)
    return match ? match.label : value
}
